import React from 'react';
import { XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET } from "../../../constants/textConstants";
import { connect } from "react-redux";
import { Divider, Typography } from "../../ecosystem/";
import InHomeSchedulingButtons from '../InHomeSchedulingButtons';
import SchedulingQuestions from '../SchedulingQuestions';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const InHomeMainPanel = connect(mapStateToProps)(({
    centerSchedulingQuestions = false,
    className,
    children,
    heading,
    subheading,
    schedulingButtons,
    screenBreakPoint,
    showSchedulingQuestions = true
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const isTablet = ([LG_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

    return (<>
        <div className={`col-12 col-xl in-home-main-panel-container ${className ? className : ''}`}>
            <div className="row with-margins in-home-main-panel__body">
                <div className={`col-12 in-home-main-panel__main-content`}>
                    {heading && <>
                        <div className="in-home-main-panel__heading">
                            <Typography
                                type={(isMobile) ? "heading-03" : isTablet ? "heading-05" : "heading-06"}
                            >
                                {heading}
                            </Typography>
                        </div>
                    </>
                    }
                    {subheading &&
                        <div className="in-home-main-panel__subheading">
                            <Typography
                                type={"body-02"}
                            >
                                {subheading}
                            </Typography>
                        </div>
                    }
                    {(isMobile && (heading || subheading)) && <Divider mTop="xsmall" mBottom="none" mLeft="none" mRight="none" />}
                    {children}
                </div>
                {showSchedulingQuestions &&
                    <div className="col-12 in-home-main-panel__need-help">
                        <SchedulingQuestions textAlign={centerSchedulingQuestions ? "center" : ""} />
                    </div>
                }
            </div>
            {schedulingButtons &&
                <InHomeSchedulingButtons {...schedulingButtons} />
            }
        </div>
    </>);
});

